import { gql } from '@apollo/client';

export const RichTextAnswerFragment = gql`
  fragment RichTextAnswerFragment on RichtextAnswer {
    answerType
    richtext
  }
`;

export const DrawAnswerFragment = gql`
  fragment DrawAnswerFragment on DrawAnswer {
    answerType
    drawing
    hasDrawingData
  }
`;

export const ImageAnswerFragment = gql`
  fragment ImageAnswerFragment on ImageAnswer {
    answerType
    image {
      key
      imageType
      fileName
      original
      alt
    }
  }
`;

export const InteractiveResponseAnswerFragment = gql`
  fragment InteractiveResponseAnswerFragment on InteractiveResponseAnswer {
    interactiveResponseItems {
      imageId
      dropZoneId
      isCorrect
    }
  }
`;

export const MultipleChoiceAnswerFragment = gql`
  fragment MultipleChoiceAnswerFragment on MultipleChoiceAnswer {
    multipleChoiceItems {
      itemId
      isSelected
      isCorrect
    }
  }
`;

export const AnswerFragment = gql`
  fragment AnswerFragment on ActivityAnswer {
    uuid
    componentId
    activityId
    answerType
    createdAt
    updatedAt
    studentId
    answer {
      ...RichTextAnswerFragment
      ...InteractiveResponseAnswerFragment
      ...DrawAnswerFragment
      ...ImageAnswerFragment
      ...MultipleChoiceAnswerFragment
    }
    answerReferences {
      id
      row
      col
    }
  }
  ${InteractiveResponseAnswerFragment}
  ${RichTextAnswerFragment}
  ${DrawAnswerFragment}
  ${ImageAnswerFragment}
  ${MultipleChoiceAnswerFragment}
`;

export const UPSERT_ACTIVITY_BUILDER_ANSWER = gql`
  mutation UpsertActivityAnswer($input: UpsertActivityAnswerInput!) {
    upsertActivityAnswer(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;

export const GET_ANSWERS = gql`
  query GetAnswers($input: GetAnswersInput!) {
    getAnswers(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;

export const GET_STUDENT_ANSWER_BY_ID = gql`
  query GetStudentAnswerById($input: GetStudentAnswerByIdInput!) {
    getStudentAnswerById(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;

export const GET_STUDENT_ANSWERS = gql`
  query GetStudentAnswers($input: GetStudentsAnswersInput!) {
    getStudentsAnswers(input: $input) {
      ...AnswerFragment
      studentId
    }
  }
  ${AnswerFragment}
`;

export const GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT = gql`
  query GetClassStudentsAnswersSummaryPerComponent(
    $input: GetStudentsAnswersInput!
  ) {
    getClassStudentsAnswersSummaryPerComponent(input: $input) {
      studentId
      numberOfAttempts
      lastAnswer {
        uuid
        answer {
          ...RichTextAnswerFragment
          ...InteractiveResponseAnswerFragment
          ...DrawAnswerFragment
          ...ImageAnswerFragment
          ...MultipleChoiceAnswerFragment
        }
      }
    }
  }
  ${InteractiveResponseAnswerFragment}
  ${RichTextAnswerFragment}
  ${DrawAnswerFragment}
  ${ImageAnswerFragment}
  ${MultipleChoiceAnswerFragment}
`;
